import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
const BadgeIcon = (_param)=>{
    var { badge } = _param, props = _object_without_properties(_param, [
        "badge"
    ]);
    const isMobile = useContext(MobileContext);
    if (badge.images.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("img", _object_spread({
        loading: "lazy",
        src: badge.images[1] ? badge.images[1].imageUrl : badge.images[0].imageUrl,
        alt: badge.baseTitle,
        width: isMobile ? 48 : 128,
        height: isMobile ? 52 : 134
    }, props));
};
BadgeIcon.displayName = 'BadgeIcon';
export default BadgeIcon;

//# sourceMappingURL=BadgeIcon.js.map